import React from 'react';
import { ControlLevelEnum } from '../../uc-api-sdk';
import EmptyComponent from '../../uiComponent/EmptyComponent/EmptyComponent';
import { ControlLevelTagComponent } from '../../features/patients/component/ControlLevelTagComponent/ControlLevelTagComponent';
import './ControlLevelEnumComponent.scss';

export const getControlLevelText = (value?: ControlLevelEnum): string => {
  switch (value) {
    case ControlLevelEnum.CONTROLLED:
      return 'Controlled';
    case ControlLevelEnum.UNCONTROLLED:
      return 'Uncontrolled';
    default:
      return 'Uncategorized';
  }
};

export interface ControlLevelEnumComponentProps {
  value: ControlLevelEnum | undefined;
  type?: 'tag' | 'filter' | 'name';
}

export const ControlLevelEnumComponent = ({
  value,
  type = 'tag',
}: ControlLevelEnumComponentProps) => {
  const getTag = (): React.ReactNode => {
    switch (value) {
      case ControlLevelEnum.CONTROLLED:
        return <ControlLevelTagComponent.ControlledTag />;
      case ControlLevelEnum.UNCONTROLLED:
        return <ControlLevelTagComponent.UncontrolledTag />;
      default:
        return <ControlLevelTagComponent.UncategorizedTag />;
    }
  };

  const getName = (): React.ReactNode => {
    const controlLevelText = getControlLevelText(value);
    switch (value) {
      case ControlLevelEnum.CONTROLLED:
        return <span className="controlled-text">{controlLevelText}</span>;
      case ControlLevelEnum.UNCONTROLLED:
        return <span className="uncontrolled-text">{controlLevelText}</span>;
      default:
        return <span className="uncategorized-text">{controlLevelText}</span>;
    }
  };

  const getFilter = (): React.ReactNode => {
    const controlLevelText = getControlLevelText(value);
    switch (value) {
      case ControlLevelEnum.CONTROLLED:
      case ControlLevelEnum.UNCONTROLLED:
      case ControlLevelEnum.UNCATEGORIZED:
        return controlLevelText;
      default:
        return <EmptyComponent />;
    }
  };

  switch (type) {
    case 'tag':
      return <>{getTag()}</>;
    case 'filter':
      return <>{getFilter()}</>;
    case 'name':
      return <>{getName()}</>;
    default:
      return <>{getTag()}</>;
  }
};
